import React from "react";

import { ArrowNewTabIcon } from "@/assets/icons";
import { formatLinkLabel, getFaviconUrl } from "@/utils/string";

import { twMerge } from "tailwind-merge";

import { FeatureLinkItem } from "./utils";

interface FeatureInfoLinksProps {
  formattedKey: string;
  links: FeatureLinkItem[];
}

export const FeatureInfoLinks: React.FC<FeatureInfoLinksProps> = ({
  formattedKey,
  links
}: FeatureInfoLinksProps) => {
  if (!links.length) return null;

  return (
    <div className="flex flex-col gap-1">
      <span className="text-dim-gray">{formattedKey}</span>
      <div className="flex flex-col gap-2">
        {links.map((linkItem, index) => {
          const faviconUrl = getFaviconUrl(linkItem.url);
          const formattedLabel = formatLinkLabel(linkItem);

          return (
            <a
              key={`${linkItem.url}-${index}`}
              href={linkItem.url}
              target="_blank"
              rel="noopener noreferrer"
              className={twMerge(
                "flex w-full items-center gap-2 text-txtHeading text-sm",
                "hover:text-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-200 rounded"
              )}
            >
              {faviconUrl ? (
                <img
                  src={faviconUrl}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  className="h-4 w-4 rounded"
                />
              ) : null}
              <span
                className="truncate text-left underline"
                title={formattedLabel}
              >
                {formattedLabel}
              </span>
              <ArrowNewTabIcon
                className="fill-dim-gray shrink-0 -ml-2"
                title="Open in new tab"
              />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default FeatureInfoLinks;
